export const BG_SHAPE_1 = 'bg-shapes-1';
export const BG_SHAPE_2 = 'bg-shapes-2';

export const BG_SHAPES = [
    BG_SHAPE_1,
    BG_SHAPE_2
];
